export default __webpack_public_path__ + "static/media/notes-app-1.6225949e.webp";